import React, { useEffect } from "react";

const Portfolio = () => {
  useEffect(() => {
    window.location.replace("/Resume.pdf");
  }, []);

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      <iframe
        src="/Resume.pdf"
        title="Resume"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default Portfolio;
